import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import de from './locales/de.json'
import pl from './locales/pl.json'
import es from './locales/es.json'

export const SUPPORTED_LANGUAGES = ['de', 'pl', 'es'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  de: 'Deutsch',
  pl: 'Polski',
  es: 'Español',
}

/** Falls back to German for an unresolved/unsupported language, e.g. i18n.resolvedLanguage before
 *  detection settles, or a language-independent route (blog, legal pages) picking a target lang
 *  for links into the /:lang/* app. */
export function resolveSupportedLang(candidate: string | undefined): SupportedLanguage {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(candidate ?? '')
    ? (candidate as SupportedLanguage)
    : 'de'
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      pl: { translation: pl },
      es: { translation: es },
    },
    fallbackLng: 'de',
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
